import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import CentralIaLibrary from 'components/organisms/central_ia_library';

import * as Shell from '../DrLicitaChat/styles';

// Biblioteca de Prompts do Dr. Licita: prompts estruturados por
// especialistas parceiros (mesma base da biblioteca do Central IA);
// "usar" leva o corpo do prompt para o chat como início de conversa.

const MODES = [
  { mode: 'peticao', title: 'Construir Petição', icon: 'edit_note' },
  { mode: 'duvidas', title: 'Dúvidas Jurídicas', icon: 'help_outline' },
  { mode: 'jurisprudencia', title: 'Jurisprudência Fácil', icon: 'gavel' },
];

const rotaDoModo = (mode: string) =>
  mode === 'jurisprudencia' ? '/dr_licita/jurisprudencia' : `/dr_licita/chat?mode=${mode}`;

const DrLicitaBiblioteca: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    document.title = 'Dr Licita - Biblioteca de Prompts';
  }, []);

  const usarPrompt = (body: string) => {
    history.push('/dr_licita/chat', { prompt: body });
  };

  return (
    <Shell.Page>
      <Shell.Sidebar>
        <h1>Dr.Licita</h1>
        <Shell.SidebarScroll>
          <Shell.SidebarButton as={Link} to="/dr_licita/chat">
            <i className="material-icons">add</i>
            Nova conversa
          </Shell.SidebarButton>
          <Shell.SidebarButton as={Link} to="/dr_licita/peticoes">
            <i className="material-icons">description</i>
            Petições
          </Shell.SidebarButton>
          <Shell.SidebarButton as={Link} to="/dr_licita/projetos">
            <i className="material-icons">folder_open</i>
            Projetos
          </Shell.SidebarButton>
          <Shell.SidebarButton active>
            <i className="material-icons">menu_book</i>
            Biblioteca de Prompts
          </Shell.SidebarButton>

          <h2>Acesso rápido</h2>
          {MODES.map((item) => (
            <Shell.SidebarButton key={item.mode} as={Link} to={rotaDoModo(item.mode)}>
              <i className="material-icons">{item.icon}</i>
              {item.title}
            </Shell.SidebarButton>
          ))}
        </Shell.SidebarScroll>

        <Shell.SidebarFooter>
          <button type="button" title="Em breve">
            <i className="material-icons">play_circle_outline</i>
            Veja como funciona
          </button>
        </Shell.SidebarFooter>
      </Shell.Sidebar>

      <Shell.Main>
        <CentralIaLibrary
          onUsePrompt={usarPrompt}
          brand="Dr. Licita"
          description={
            'Prompts estruturados e validados por especialistas em contratações públicas. ' +
            'Utilize-os como base para iniciar conversas com o Dr. Licita e personalize os ' +
            'campos conforme o seu contexto.'
          }
          showProviderConfig={false}
          background="#f5f7fa"
        />
      </Shell.Main>
    </Shell.Page>
  );
};

export default DrLicitaBiblioteca;
